// eslint-disable-next-line import/no-unresolved
import { gql } from 'graphql-request';

export const getWhiteList = gql`
  query TokenWhiteList($tokenHash: String) {
    getTokenWhitelist(include: $tokenHash)
  }
`;
